export default "__VITE_ASSET__B4jjBHHH__"